import gql from "graphql-tag";

export const GET_USER_CONTEXT_DATA = gql`
	query GetCurrentOrganization {
		CurrentOrganization {
			id
			name
			currencyCodes {
				Code
				Name
			}
			documentSftpSavePath
			isExternalExposureAllowed
			agreementTagNames
			downloadPAFeatureEnabled
			libraryGPTFeatureEnabled
			libraryNavlinPricesEnabled
			simulatorProductInputEnabled
			simulatorBreakdownEnabled
			simulatorWasteReportingEnabled
			simulatorPVThresholdsEnabled
			simulatorModelValidityEnabled
			validityCoverageEnabled
			encapsulatedFeatures {
				isEnabled
				ofType {
					key
					title
				}
			}
			currencyCodes {
				Name
				Code
			}
			agreementTagNames
			agreementRunTriggers
		}
	}
`;
